import React from 'react';
import {
    AiOutlinePaperClip,
    AiOutlineCheck   
} from 'react-icons/ai';


let AttachCard = (props) => {
    const getIcon = (icon) => {
        if (!props.attached) return <AiOutlinePaperClip />
        else return <AiOutlineCheck />
    }
    return (
        <div className='icon-card'>
            <div className='icon-card-content' onClick={() => { document.getElementById('uploadAssetsInput').click() }}>
                    <input type="file" id='uploadAssetsInput' onChange={(e) => { props.setFile(e.target.files[0]) }} style={{ display: 'none' }} />
                <div style={{ fontSize: 100 }} >{getIcon()}</div>
                <div style={{ fontSize: 24, textAlign: 'center' }}>{props.subText}</div>

            </div>
        </div>
    )
    ;
}
export default AttachCard;